export default "__VITE_ASSET__Bh5$e2Bj__"